import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { PortalService } from "../../../services/portal-service.service";
import { AuthService } from "../../../services/auth.service";
import { LogService } from "../../../services/log.service";

@Component({
  standalone: false,
  selector: "app-account-details-tab",
  templateUrl: "./account-details-tab.component.html",
  styleUrls: ["./account-details-tab.component.scss"],
})
export class AccountDetailsTabComponent implements OnInit {
  AccountDetailsForm: UntypedFormGroup;
  constructor(
    private fb: UntypedFormBuilder,
    private authService: AuthService,
    private portalService: PortalService,
    private logService: LogService,
  ) {}
  countries = [];
  comapny = "";
  showMessage = false;
  error: any = null;
  saving = false;

  ngOnInit() {
    this.getCountries();
    this.AccountDetailsForm = this.fb.group({
      userName: ["", [Validators.required]],
      email: [{ value: "", disabled: true }, [Validators.required]],
      address1: ["", [Validators.required]],
      address2: "",
      address3: "",
      address4: "",
      city: ["", [Validators.required]],
      state: ["", [Validators.required]],
      country: ["", [Validators.required]],
      postCode: ["", [Validators.required]],
      password: ["", [Validators.required]],
      emailUpdates: [true],
    });
    this.getDetails();
  }

  emailUpdates: boolean;
  async getDetails() {
    const user = this.authService.getToken();
    let userId = null;
    if (user) {
      userId = this.authService.JWTDecode(user).sub;
      const data: any = await this.portalService.getUser(userId);
      this.f.userName.setValue(data.username);
      this.f.email.setValue(data.email);
      this.f.address1.setValue(data.address1);
      this.f.address2.setValue(data.address2);
      this.f.address3.setValue(data.address3);
      this.f.address4.setValue(data.address4);
      this.f.city.setValue(data.city);
      this.f.postCode.setValue(data.zip);
      this.f.state.setValue(data.state);
      this.f.country.setValue(data.country);
      this.comapny = data.company;
      this.f.emailUpdates.setValue(data.emailUpdates);
      this.emailUpdates = data.emailUpdates;
    }
  }

  async getCountries() {
    this.countries = await this.portalService.getCountries();
  }

  get f() {
    return this.AccountDetailsForm.controls;
  }

  async updateUser() {
    this.resetMessage();
    if (this.saving) return;
    this.saving = true;
    const user = this.authService.getToken();
    const userId = this.authService.JWTDecode(user).sub;
    const data = {
      user: {
        id: userId,
        username: this.f.userName.value,
        email: this.f.email.value,
        company: this.comapny,
        address1: this.f.address1.value,
        address2: this.f.address2.value,
        address3: this.f.address3.value,
        address4: this.f.address4.value,
        city: this.f.city.value,
        zip: this.f.postCode.value,
        state: this.f.state.value,
        country: this.f.country.value,
        emailUpdates: this.f.emailUpdates.value,
      },
      existingPassword: this.f.password.value,
    };
    try {
      await this.portalService.updateUser(userId, data);
      this.showMessage = true;
      this.getDetails();
    } catch (error) {
      this.error = error;
    } finally {
      this.saving = false;
    }
  }

  resetMessage() {
    this.showMessage = false;
    this.error = null;
  }

  saveDisabled(): boolean {
    return this.saving || this.AccountDetailsForm.invalid;
  }
} // end
